import { render, staticRenderFns } from "./EditSpecies.vue?vue&type=template&id=1be364f8&scoped=true&"
import script from "./EditSpecies.vue?vue&type=script&lang=js&"
export * from "./EditSpecies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be364f8",
  null
  
)

export default component.exports